angular.module('bmsApp.trugreen.visitplanner', [
	'ui.router'
])
	.config([
		'$stateProvider', function config($stateProvider) {

			$stateProvider

				.state('main.trugreen.visitplanner', {
					url: '^/trugreen/visitplanner/{quoteId}/return/{return}',
					views: {
						'main@main': {
							templateUrl: 'ng/trugreen/visitPlanner/templates/VisitPlanner.html',
							controller: 'TGVisitPlannerCtrl'
						}
					},
					ncyBreadcrumb: { label: 'Visit Planner' }
				})

			;

		}]);
